import { desktopContentMinWidthExclusive } from 'layouts/styles';

export default {
  wrapperNew: {
    margin: '0 auto',
    flex: 1,
  },
  phoneMinWidth: {
    minWidth: desktopContentMinWidthExclusive,
    '@media screen and (max-width: 600px)': {
      minWidth: 0,
    },
  },
};
